import wrapWithProvider from "./src/services/auth.wrapper";
import LayoutWrapper from './src/templates/LayoutWrapper/LayoutWrapper';

export const wrapRootElement = wrapWithProvider;
export const wrapPageElement = LayoutWrapper;

